import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/applications/$applicationId")({
  component: ApplicationLayoutComponent,
});

function ApplicationLayoutComponent() {
  return <Outlet />;
}
